var _rect, _path, _rect2, _g, _rect3, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLibraryEmptyState(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 286,
    height: 147,
    viewBox: "0 0 286 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 101.5,
    y: 11.5,
    width: 85,
    height: 85,
    rx: 15.5,
    fill: "#F6F7F9",
    stroke: "#E5E7EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M125.666 53.9998H162.333M125.666 44.8332H134.833M153.166 44.8332H162.333M125.666 63.1665H134.833M153.166 63.1665H162.333M134.833 72.3332V35.6665M153.166 72.3332V35.6665M134.466 72.3332H153.533C156.613 72.3332 158.153 72.3332 159.33 71.7337C160.365 71.2064 161.206 70.365 161.733 69.3301C162.333 68.1536 162.333 66.6135 162.333 63.5332V44.4665C162.333 41.3862 162.333 39.8461 161.733 38.6696C161.206 37.6347 160.365 36.7933 159.33 36.266C158.153 35.6665 156.613 35.6665 153.533 35.6665H134.466C131.386 35.6665 129.846 35.6665 128.669 36.266C127.634 36.7933 126.793 37.6347 126.265 38.6696C125.666 39.8461 125.666 41.3862 125.666 44.4665V63.5332C125.666 66.6135 125.666 68.1536 126.265 69.3301C126.793 70.365 127.634 71.2064 128.669 71.7337C129.846 72.3332 131.386 72.3332 134.466 72.3332Z",
    stroke: "#CED2D6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.6124,
    y: 52.3536,
    width: 85,
    height: 85,
    rx: 15.5,
    transform: "rotate(-15 12.6124 52.3536)",
    fill: "#F6F7F9",
    stroke: "#E5E7EA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_664_1293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.4003 100.679L62.9518 85.8677C63.4652 84.9785 63.7219 84.5339 64.091 84.2942C64.4157 84.0833 64.7989 83.9807 65.1855 84.001C65.625 84.024 66.0697 84.2807 66.9588 84.7941L81.6717 93.2885M68.9092 85.9201L72.628 79.479C73.1414 78.5898 73.3981 78.1452 73.7672 77.9055C74.0919 77.6946 74.475 77.592 74.8617 77.6122C75.3012 77.6353 75.7458 77.8919 76.635 78.4053L83.0761 82.1241M58.9788 77.1929C59.5029 79.149 58.3421 81.1596 56.386 81.6837C54.43 82.2078 52.4194 81.047 51.8953 79.0909C51.3712 77.1349 52.532 75.1243 54.488 74.6002C56.4441 74.0761 58.4546 75.2369 58.9788 77.1929ZM59.006 99.9617L77.423 95.0269C80.3983 94.2297 81.886 93.831 82.8673 92.9475C83.7304 92.1703 84.3254 91.1398 84.5669 90.0037C84.8414 88.7121 84.4428 87.2245 83.6455 84.2491L79.6597 69.3739C78.8625 66.3986 78.4639 64.9109 77.5803 63.9296C76.8031 63.0665 75.7727 62.4715 74.6365 62.23C73.345 61.9555 71.8573 62.3541 68.882 63.1513L50.465 68.0862C47.4897 68.8834 46.002 69.282 45.0207 70.1656C44.1576 70.9427 43.5626 71.9732 43.3211 73.1093C43.0466 74.4009 43.4452 75.8886 44.2425 78.8639L48.2283 93.7392C49.0255 96.7145 49.4241 98.2022 50.3077 99.1834C51.0848 100.047 52.1153 100.642 53.2514 100.883C54.543 101.158 56.0307 100.759 59.006 99.9617Z",
    stroke: "#CED2D6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 191.436,
    y: 30.6124,
    width: 85,
    height: 85,
    rx: 15.5,
    transform: "rotate(15 191.436 30.6124)",
    fill: "#F6F7F9",
    stroke: "#E5E7EA"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_664_1293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.798 66.6623L227.838 73.9769C227.572 74.9687 227.439 75.4645 227.53 75.8951C227.611 76.2738 227.809 76.6173 228.097 76.8763C228.424 77.1709 228.92 77.3037 229.912 77.5695L237.226 79.5294M228.248 86.6135L214.081 82.8175M226.35 93.6969L212.183 89.9009M219.52 76.683L215.979 75.734M229.925 66.185L220.717 63.7175C217.742 62.9203 216.254 62.5217 214.962 62.7962C213.826 63.0377 212.796 63.6327 212.019 64.4958C211.135 65.4771 210.736 66.9648 209.939 69.9401L205.004 88.3571C204.207 91.3324 203.809 92.8201 204.083 94.1116C204.325 95.2478 204.919 96.2782 205.783 97.0554C206.764 97.939 208.252 98.3376 211.227 99.1348L222.56 102.172C225.536 102.969 227.023 103.367 228.315 103.093C229.451 102.851 230.482 102.257 231.259 101.393C232.142 100.412 232.541 98.9244 233.338 95.9491L237.704 79.6572L229.925 66.185Z",
    stroke: "#CED2D6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_664_1293"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white",
    transform: "translate(37 66) rotate(-15)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_664_1293"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white",
    transform: "translate(206.082 56) rotate(15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibraryEmptyState);
export default __webpack_public_path__ + "static/media/library_empty_state.d545398b930021059d7e8bc66b0fda5f.svg";
export { ForwardRef as ReactComponent };